import { Controller } from "stimulus"
import Utility from '../classes/Utility';
import ShowChatbot from '../data_services/components/show_chatbot';
const urlParams = new URLSearchParams(window.location.search);

class MultiChatbotController extends Controller {
  async initialize() {
    this.chatbotType = null;
    this.chatbotArray = this.element.dataset.chatbots.split(',');
    this.getChatbotType()
  }

  renderConditionSatisfied = (type) => {
    const userClosed = Utility.getCookie(`${type}_closed`);
    const userDone = Utility.getCookie(`${type}_complete`);

    return userClosed === 'unknown' && userDone === 'unknown'
  }

  getChatbotType = () => {
    if (urlParams.get('annuityemail') == 'true') {
      this.chatbotType = 'annuity';
      return
    }

    if (this.renderConditionSatisfied('annuity')) {
      this.chatbotType = 'annuity';
      return;
    }

    this.chatbotType = null; 
    return;
  }

  connect() {
    if (this.chatbotType) {
      const uuid = Utility.getCookie('mid');
      if (uuid == 'unknown') {
        ShowChatbot('annuity')
      } else {
        ShowChatbot(this.chatbotType)
      }
    }
  }

  removeSelf() {
    this.element.dataset['controller'] = ''
  }
}

export default MultiChatbotController;
